// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"585":"500dd4cc","832":"cf1b0ede"}[chunkId] + ".chunk.js");